import moduleRender from '../moduleRender';
export default function({ modules, ...params }) {
    return modules.map((module) => moduleRender({ ...params, module }));
}